const escapeMap: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;',
};

const unescapeMap = Object.keys(escapeMap).reduce(
  (memo, key) => {
    memo[escapeMap[key]] = key;
    return memo;
  },
  {} as Record<string, string>
);

const reHasUnescapedChars = /[&<>"'`=]/g;
const reHasEscapedChars = /&(?:amp|lt|gt|quot|#x27|#x60|#x3D);/g;

function escapeCharacter(char: string) {
  return char in escapeMap ? escapeMap[char] : char;
}

export function escape(str: string) {
  return reHasUnescapedChars.test(str) ? str.replace(reHasUnescapedChars, escapeCharacter) : str;
}

function unescapeCharacter(char: string) {
  return char in unescapeMap ? unescapeMap[char] : char;
}

export function unescape(str: string) {
  return reHasEscapedChars.test(str) ? str.replace(reHasEscapedChars, unescapeCharacter) : str;
}

export function unescapeUnknown<T>(value: T): T {
  if (!value || value === null) {
    return value;
  }

  if (typeof value === 'string') {
    return unescape(value) as unknown as T;
  }

  if (Array.isArray(value)) {
    return value.map((v) => unescapeUnknown(v)) as unknown as T;
  }

  if (value && typeof value === 'object' && Object.prototype.toString.call(value) === '[object Object]') {
    return Object.entries(value).reduce(
      (memo, [key, value]) => {
        memo[key] = unescapeUnknown(value);
        return memo;
      },
      {} as Record<string, unknown>
    ) as T;
  }

  return value;
}
